import React from "react";
import { FiChevronLeft, FiX } from "react-icons/fi";
import Logo from "Assets/images/logo.svg";
import styles from "./AssessmentUpliftHeader.module.scss";

export interface AssessmentUpliftHeaderProps {
  onBack?: () => void;
  onClose?: () => void;
}

const AssessmentUpliftHeader: React.FC<AssessmentUpliftHeaderProps> = ({
  onBack,
  onClose,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles["nav-slot"]}>
        {onBack && (
          <button
            type="button"
            className={styles["nav-button"]}
            aria-label="go to previous step"
            onClick={onBack}
          >
            <FiChevronLeft size={24} />
          </button>
        )}
      </div>

      <img src={Logo} alt="Wone Logo" className={styles.logo} />

      <div className={styles["nav-slot"]}>
        {onClose && (
          <button
            type="button"
            className={`${styles["nav-button"]} ${styles["close-button"]}`}
            aria-label="exit assessment button"
            onClick={onClose}
          >
            <FiX size={20} />
          </button>
        )}
      </div>
    </div>
  );
};

export default AssessmentUpliftHeader;
